import r from "deepmerge";
import "./base-theme/breakpoints.js";
import "theme-ui";
import "./base-theme/components/collapsible.js";
import "./base-theme/components/dialogs.js";
import "./base-theme/components/forms/forms.js";
import "./base-theme/components/forms/input.js";
import "./base-theme/components/skeletons.js";
import "./base-theme/components/tags.js";
import "./base-theme/components/toast.js";
import "./base-theme/components/tooltips.js";
import "./base-theme/keyframes.js";
import { baseTheme as o } from "./base-theme/theme.js";
import { outline as t } from "./outline.js";
import { badgesTheme as m } from "./components/badges.js";
import { buttonsTheme as i } from "./components/buttons.js";
import { dialogsTheme as p } from "./components/dialogs.js";
import { dropdownsTheme as a } from "./components/dropdowns.js";
import { forms as s } from "./components/forms/forms.js";
import { inputsTheme as l } from "./components/forms/input.js";
import { switchesTheme as h } from "./components/forms/switch.js";
import { progressBarTheme as n } from "./components/progress.js";
import { segmentedControlsTheme as d } from "./components/segmentedControl.js";
import { skeletonsTheme as f } from "./components/skeletons.js";
import { tagsTheme as g } from "./components/tags.js";
import { textTheme as x } from "./components/text.js";
import { toastsTheme as T } from "./components/toasts.js";
const P = r(
  o,
  {
    colors: {
      accent: "#FFE600",
      black: "#27272C",
      cardOverlay: "#F5F5F7",
      disabledText: "#86868b",
      lightGray3: "#e4e4e4",
      error: "#ED6DB8",
      primary: "#4D4E58",
      secondary: "#F2F2F2",
      secondaryText: "#86868B",
      stroke: "#F2F2F2",
      success: "#7DC64E",
      sustainability: "#44D62C"
    },
    fontSizes: {
      "2xs": 10,
      // Caption 3
      xs: 12,
      // Caption 2
      sm: 13,
      // Caption 1
      md: 16,
      // Body
      lg: 20,
      xl: 24,
      // Headline 1
      headline2: 20,
      headline3: 16,
      h1: 80,
      // Large Title
      h2: 60,
      // Title 1
      h3: 36,
      // Title 2
      h4: 28
      // Title 3
    },
    fontWeights: {
      bold: 600,
      regular: 400
    },
    forms: s,
    letterSpacings: {
      h2: "-0.02em",
      // Title 1
      h3: "-0.02em",
      // Title 2
      largeTitle: "-0.02em"
    },
    lineHeights: {
      label3: "16px",
      // Caption 3
      label: "20px",
      // Caption 1, 2
      body: "24px",
      headline1: "32px",
      headline2: "32px",
      headline3: "24px",
      title1: "60px",
      title2: "48px",
      title3: "36px",
      largeTitle: "80px"
    },
    outline: t,
    zIndices: {
      cardOverlay: 1,
      controllers: 2,
      inspirationHeader: 3,
      pageHeader: 4,
      dialogOverlay: 10,
      dropdownMenu: 100
    },
    ...m,
    ...i,
    ...p,
    ...a,
    ...l,
    ...d,
    ...f,
    ...h,
    ...g,
    ...x,
    ...T,
    ...n
  },
  {
    arrayMerge: (c, e) => e
  }
);
export {
  P as theme
};
